export const environment = {
  production: false,
  API_URL_SQL_REPORT: '/backend-api',
  API_URL_LOGIN: '/backend-login',
  API_URL_PUBLIC: 'https://sql.api.test.gtsi.pe'
};
